/* eslint-disable @typescript-eslint/no-explicit-any */
import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'
import { List } from 'antd'
import { JSX } from 'react'
import styled from 'styled-components'
import HelperLink from './HelperLink'
import Text from './Text'

const HelperListStyles = styled(List)`
  &.ant-list {
    > .ant-list-header {
      padding: 20px;
      border: none;
      > span {
        color: #373737 /* character/primary */;
        font-weight: var(--typography-weight-bold);
        font-size: 20px;
        line-height: 28px;
      }
    }
  }
`

const HelperListLogic = ({ Wrapper }: { Wrapper: any }) => {
  const {
    parsedHelpers,
    copies: { header: copy },
  } = useHeaderContext()
  const { help } = copy

  if (!parsedHelpers?.length) {
    return null
  }

  return (
    <Wrapper
      header={<Text text={help} />}
      dataSource={parsedHelpers}
      renderItem={(
        item: JSX.IntrinsicAttributes & {
          href: string
          target: string
          icon: string
          text: string
        }
      ) => <HelperLink {...item} />}
    />
  )
}

const HelperList = () => <HelperListLogic Wrapper={HelperListStyles} />

export default HelperList
